// function setSectionHeight() {
//   let section = document.querySelector('.product-gallery__ar-wrapper');
//   if (!section) {
//     console.error('Section element not found. Check the class name.');
//     return;
//   }

//   let sectionHeight = section.offsetHeight + 'px';
//   document.documentElement.style.setProperty('--pdp-product-gallery', sectionHeight);
// }
// setSectionHeight();
// window.addEventListener('resize', setSectionHeight);

{
  function setSectionHeight() {
    const arWrapper = document.querySelector('.product-gallery__ar-wrapper');
    const thumbnailWrapper = document.querySelector('.product-gallery__thumbnail-list-wrapper');
    
    if (arWrapper) {
      const arHeight = arWrapper.offsetHeight;
      // const currentThumbHeight = thumbnailWrapper.offsetHeight;      
      document.documentElement.style.setProperty('--pdp-product-gallery', `${arHeight}px`);
    }
  }
  setSectionHeight();
  window.addEventListener('resize', setSectionHeight);
}

{
  window.setGridHeight = (selector) => {
    let gridOffsets = [];
    let gridRowOffsets = []
 
    gridOffsets = Array.from(document.querySelectorAll(selector)).map((element,index) => {
      let grid = element.closest('.griditem') || element.closest('[data-equal]');
      element.removeAttribute('style');
      return {
        selector:element,
        selectorHeight: element.offsetHeight,
        offsetTop: grid.offsetTop,
      }
    });
 
    let offsets = gridOffsets.map(element => element.offsetTop);
    gridRowOffsets = [...new Set(offsets)];
 
    gridRowOffsets.forEach(rowOffset => {
      let rowGrids = gridOffsets.filter(grid => (grid.offsetTop == rowOffset));
      let comanElementHeight = Math.max.apply(Math,(rowGrids.map(ele => ele.selectorHeight)));
      rowGrids.forEach(grid => {
        grid.selector.style.minHeight = comanElementHeight+'px';
      });
    });
  }
 
 setTimeout(() => {
    matchHeightCallback();
  }, 2000)
  
  window.addEventListener('resize', function(event){
    matchHeightCallback();
  });
 
  let matchHeightCallback = () => {
    window.setGridHeight('.item_boxs.custom_image .box_item'); 
  }
  matchHeightCallback();
}
// ============================================
// FREE GIFT GUARD — supports multiple gift types
// ============================================

async function checkAndRemoveFreeGift(cartData) {
  try {
    const cart = cartData || await fetch('/cart.js').then(res => res.json());

    const eligibleGiftTypes = new Set(
      cart.items
        .filter(item =>
          item.properties &&
          item.properties['_subscription_product'] === 'true' &&
          item.properties['_gift_eligible'] === 'true'
        )
        .map(item => item.properties['_gift_type'] || 'regular')
    );

    const freeGiftItems = cart.items.filter(
      item => item.properties &&
              item.properties['_subscription_free_gift'] === 'true'
    );

    if (freeGiftItems.length === 0) return;

    let removedSomething = false;
    for (const giftItem of freeGiftItems) {
      const giftType = giftItem.properties['_free_gift_type'] || 'regular';
      if (!eligibleGiftTypes.has(giftType)) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftItem.key, quantity: 0 })
        });
        removedSomething = true;
      }
    }

    if (removedSomething) {
      window.location.reload();
    }

  } catch(error) {
    console.error('Free gift guard error:', error);
  }
}

// Cart drawer
document.documentElement.addEventListener('cart:change', (event) => {
  if (event.detail?.cart) {
    checkAndRemoveFreeGift(event.detail.cart);
  }
});

// Cart page
document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname.includes('/cart')) {
    checkAndRemoveFreeGift(null);
  }
});